module.exports = __webpack_public_path__ + "static/media/acmg-cert-heading.3b540ecf.png";